export const COVID19_NAME = "Coronavirus (COVID-19)";
export const COVID19_ID = "FE.a71874d1-b407-401e-8d82-32fc449e9444";
//endregion [[ Functions ]]
export const COVID19_DD_PANEL = "FE.673cfde8-be3a-4eb2-91fa-bef2d10cb3ae";
